/**
 * @author Daniel Aguirre
 * @file constants.js
 * @description Components State Constants
 */

// Generic actions
export const GET_NEPHRO_MASTER_STATE =
  'ComponentsState/GET_NEPHRO_MASTER_STATE';
export const GET_NEPHRO_AUTH_STATE = 'ComponentsState/GET_NEPHRO_AUTH_STATE';
export const GET_NEPHRO_INTEGRATOR_STATE =
  'ComponentsState/GET_NEPHRO_INTEGRATOR_STATE';
export const GET_NEPHRO_CALENDAR_STATE =
  'ComponentsState/GET_NEPHRO_CALENDAR_STATE';
export const GET_NEPHRO_MEDIA_STATE = 'ComponentsState/GET_NEPHRO_MEDIA_STATE';
export const GET_NEPHRO_COMMON_STATE =
  'ComponentsState/GET_NEPHRO_COMMON_STATE';
